<template>
	<core-modal
		name="email-upsell"
		class="omapi-email-upsell"
		:width="766"
	>
		<div class="close">
			<button
				type="button"
				class="unbutton"
				@click.prevent="$modal.hide('email-upsell')"
			><svg-close/></button>
		</div>
		<modals-content class="omapi-multi-column flex omapi-email-upsell__content">
			<h4 class="omapi-email-upsell__title">Want to send a bulk email all your contacts?<br>Get started with Email Marketing!</h4>
			<div class="omapi-email-upsell__text">OptinMonster makes it easy for you to connect your optin forms with popular email marketing services, so you can easily send personalized email newsletters to your subscribers. Below are the top providers that we recommend.</div>
			<div class="omapi-email-upsell__providers">
				<div class="omapi-email-upsell__provider omapi-multi-column omapi-flex omapi-flex-row" @click.prevent="goTo('redirect/constant-contact/')">
					<div class="omapi-multi-column__secondary omapi-icon-wrapper omapi-icon-wrapper__left">
						<img src="../../../assets/images/logo-constant-contact.png" alt="Constant Contact Logo">
					</div>
					<div class="omapi-multi-column__primary">
						<h3 class="omapi-multi-column__title omapi-email-upsell__preferred">Constant Contact</h3>
						<div class="omapi-multi-column__text">Constant Contact is the leading email marketing service for small business. It comes with beautiful email templates, email automation, A/B testing, and more.</div>
						<div class="omapi-multi-column__link">
							<core-button
								:href="$urls.app('redirect/constant-contact/')"
								target="_blank"
								rel="noopener"
								class="omapi-link-arrow-after"
								:linkStyle="true"
							>Send email newsletter with Constant Contact</core-button>
						</div>
					</div>
				</div>
				<div class="omapi-email-upsell__provider omapi-multi-column omapi-flex omapi-flex-row" @click.prevent="goTo('redirect/sendinblue/')">
					<div class="omapi-multi-column__secondary omapi-icon-wrapper omapi-icon-wrapper__left">
						<img src="../../../assets/images/logo-sendinblue.png" alt="Sendinblue Logo">
					</div>
					<div class="omapi-multi-column__primary">
						<h3 class="omapi-multi-column__title">Sendinblue</h3>
						<div class="omapi-multi-column__text">Sendinblue is the smartest and most intuitive platform for growing businesses. Communicate with your contacts via email, SMS, Live Chat and more.</div>
						<div class="omapi-multi-column__link">
							<core-button
								:href="$urls.app('redirect/sendinblue/')"
								target="_blank"
								rel="noopener"
								class="omapi-link-arrow-after"
								:linkStyle="true"
							>Send email newsletter with Sendinblue</core-button>
						</div>
					</div>
				</div>
			</div>
			<div class="omapi-email-upsell__text-disclaimer">Once you signup with your email marketing service, you need to import your subscribers. Also don't forget to add your email marketing service to your OptinMonster forms, so we can automatically sync all future subscribers with your email list.</div>
		</modals-content>
	</core-modal>
</template>

<script lang="js">

export default {
	methods : {
		goTo (path) {
			window.open(this.$urls.app(path), '_blank', 'noopener')
		},
	},
}
</script>

<style lang="scss">
@import '../../../assets/scss/variables';
.omapi-screen .v--modal-overlay.omapi-email-upsell {
	.v--modal {
		border-radius: 0;
		.omapi-email-upsell {
			&__content {
				flex-direction: column;
				text-align: center;
				padding: 0 90px 56px;
			}
			&__title {
				font-size: 24px;
				line-height: 1.4em;
				margin-top: 0;
				margin-bottom: 24px;
			}
			&__text {
				font-size: 16px;
				line-height: 1.5em;
				margin-bottom: 50px;
				&-disclaimer {
					font-size: 14px;
					margin: 26px 0 0;
				}
			}
			&__provider {
				margin-bottom: 24px;
				border: solid 1px #C9D0D6;
				max-width: 570px;
				padding: 20px 30px;
				text-align: left;
				display: flex;
				align-items: center;
				box-shadow: 1px 3px 2px rgba(0, 0, 0, 0.05);
				border-radius: 3px;
				cursor: pointer;
				.omapi-multi-column {
					&__title {
						margin: 0 0 10px;
						font-size: 16px;
						line-height: 1em;
					}
					&__text,
					&__link {
						font-size: 14px;
						line-height: 1.5em;
					}
				}
			}
			&__preferred:after {
				content: 'Preferred';
				font-size: 10px;
				margin-left: 10px;
				background-color: #46B450;
				color: white;
				padding: 4px 11px 5px;
				border-radius: 2px;
				vertical-align: top;
				text-transform: uppercase;
			}
		}
		.close {
			display: flex;
			justify-content: flex-end;
			button {
				padding: 30px 30px 0;
				&:hover {
					cursor: pointer;
				}
				svg {
					color: $font_setting-color;
				}
			}
		}
	}
}
</style>
